import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _toArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import Prism from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
function fetchGhostBlogPosts(_x) {
  return _fetchGhostBlogPosts.apply(this, arguments);
}
function _fetchGhostBlogPosts() {
  _fetchGhostBlogPosts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(api) {
    var _ref3,
      pinnedPostId,
      limit,
      data,
      pinnedPost,
      postLimit,
      posts,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, pinnedPostId = _ref3.pinnedPostId, limit = _ref3.limit;
          data = [];
          if (!pinnedPostId) {
            _context.next = 12;
            break;
          }
          _context.prev = 3;
          _context.next = 6;
          return api.posts.read({
            id: pinnedPostId
          }, {
            include: "authors"
          });
        case 6:
          pinnedPost = _context.sent;
          data.push(pinnedPost);
          _context.next = 12;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
        case 12:
          postLimit = Number(limit) || 3;
          _context.prev = 13;
          _context.next = 16;
          return api.posts.browse({
            limit: postLimit,
            include: "authors"
          });
        case 16:
          posts = _context.sent;
          data.push.apply(data, _toConsumableArray(posts));
          _context.next = 22;
          break;
        case 20:
          _context.prev = 20;
          _context.t1 = _context["catch"](13);
        case 22:
          return _context.abrupt("return", data.slice(0, postLimit).map(mapper));
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10], [13, 20]]);
  }));
  return _fetchGhostBlogPosts.apply(this, arguments);
}
function sanitize(excerpt) {
  var words = excerpt.replace(/[\n\r]+/g, " ").replace(/\s+\[(http|\/)[^\]]+]?/g, "").replace(/^\s+|\s+$/g, "").split(/\s+/).filter(Boolean).slice(0, 30);
  var last = words[words.length - 1];
  return "".concat(words.join(" ")).concat(/\.$/.test(last) ? "" : "\u2026");
}
function mapper(_ref) {
  var customExcerpt = _ref.custom_excerpt,
    excerpt = _ref.excerpt,
    id = _ref.id,
    metaDescription = _ref.meta_description,
    primary_author = _ref.primary_author,
    title = _ref.title,
    url = _ref.url;
  var _ref2 = primary_author || {},
    _ref2$name = _ref2.name,
    author = _ref2$name === void 0 ? "" : _ref2$name,
    _ref2$profile_image = _ref2.profile_image,
    userImageURL = _ref2$profile_image === void 0 ? null : _ref2$profile_image;
  return {
    id: id,
    title: title || "",
    summary: metaDescription || customExcerpt || sanitize(excerpt || ""),
    author: author,
    url: url || "https://blog.streamr.network/",
    userImageURL: userImageURL
  };
}
var W = typeof window === "undefined" ? void 0 : window;
var D = typeof document === "undefined" ? void 0 : document;
function injectHubSpotScript() {
  return _injectHubSpotScript.apply(this, arguments);
}
function _injectHubSpotScript() {
  _injectHubSpotScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return new Promise(function (resolve, reject) {
            if (W !== null && W !== void 0 && W.hbspt) {
              return void resolve();
            }
            if (!D) {
              return void reject(new Error("No DOM"));
            }
            var script = document.createElement("script");
            script.src = "//js.hsforms.net/forms/v2.js";
            script.async = true;
            script.onload = function () {
              resolve();
              if (D) {
                D.body.removeChild(script);
              }
            };
            script.onerror = function (e) {
              reject(e);
            };
            D.body.appendChild(script);
          });
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _injectHubSpotScript.apply(this, arguments);
}
function injectHubSpotForm(_x2, _x3, _x4, _x5) {
  return _injectHubSpotForm.apply(this, arguments);
}
function _injectHubSpotForm() {
  _injectHubSpotForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formId, portalId, target, onFormSubmitted) {
    var _ref4,
      signal,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref4 = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {}, signal = _ref4.signal;
          _context3.prev = 1;
          _context3.next = 4;
          return injectHubSpotScript();
        case 4:
          if (!(signal !== null && signal !== void 0 && signal.aborted)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          if (W) {
            W.jQuery = W.jQuery || function () {};
          }
          if (W !== null && W !== void 0 && W.hbspt) {
            W.hbspt.forms.create({
              cssClass: "root",
              errorClass: "invalid",
              errorMessageClass: "errors",
              formId: formId,
              onFormSubmitted: onFormSubmitted,
              portalId: portalId,
              submitButtonClass: "submitInput",
              target: target
            });
          }
          _context3.next = 12;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](1);
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 10]]);
  }));
  return _injectHubSpotForm.apply(this, arguments);
}
var nw = Prism.plugins.NormalizeWhitespace;
function normalizeWhitespace(code, config) {
  return nw.normalize(code, config);
}
function titleize(value) {
  return value.replace(/\w/, function (s) {
    return s.toUpperCase();
  });
}
function defaultWsNormalizer(s) {
  return s;
}
function tokenize(code) {
  var wsNormalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWsNormalizer;
  var tokens = Prism.tokenize(wsNormalizer(code), Prism.languages.javascript);
  var lines = [];
  var line = [];
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (!line.length) {
      lines.push(line);
    }
    if (typeof token === "string") {
      var _token$split = token.split(/\n/),
        _token$split2 = _toArray(_token$split),
        tail = _token$split2[0],
        rest = _token$split2.slice(1);
      line.push(tail);
      if (!rest.length) {
        continue;
      }
      line = [];
      for (var j = 0; j < rest.length - 1; j++) {
        lines.push([rest[j]]);
      }
      line.push(rest[rest.length - 1]);
      lines.push(line);
      continue;
    }
    line.push(token);
  }
  return lines;
}
export { fetchGhostBlogPosts, injectHubSpotForm, normalizeWhitespace, titleize, tokenize };